



import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import MyNav from '@/components/skeleton/top.vue'; // 骨架结构顶部
import { Button, Message } from 'element-ui';

    @Component({
      components: {
        MyNav,
        Button,
      },
    })
export default class extends Vue {
        @Getter public navData: any;

        @Getter public skeleton: any;

        @Mutation public setSkeletonDescribe;

        @Mutation public openDialog;

        @Mutation public closeDialog;

        private title: any = '';

        private created() {
          // NProgress.start();

          this.setSkeletonDescribe(false);
          //     NProgress.done();
          this.title = '';
        }

        /* 按钮 - 相关的变量及参数 */
        private operat:any = '0';

        private operation(index:number) {
          this.operat = index;
        }

        private buttons :any = ['我的资料', '修改密码', '开通新课程', '课程设置', '消息中心', '帮助与反馈']
}
